import React, { useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelectionDropdown from 'components/multiSelectDropdown'
import { redListOfEcosystemCategory } from 'constants/redListOfEcosystemCategory'
import { FiltersContentContainer } from '../style'
import qs from 'query-string'

const getEcosystemUrl = (defaultList, selectedList, redListCategory ) => {
  const selectedEcosystem = defaultList.filter((element) => {
    return selectedList.includes(element.value)
  }).map((ecosystem) => {
    return ecosystem.label
  })

  return qs.stringify({
    ecosystem: selectedEcosystem.toString(),
    ecosystemCategory: redListCategory.toString()
  }, { skipEmptyString: true, skipNull: true })
}


const EcosystemFiltersContent = ({ item, updateFilters, filterTitle, ecosystemOptions }) => {
  const [ecosystemList, setEcosystemList] = useState(item.ecosystemList)
  const [ecosystemRedListCategory, setEcosystemRedListCategory] = useState(item.ecosystemRedListCategory)
  const [ecosystemQuery, setEcosystemQuery] = useState('')

  const handleChangeEcosystemList = (e) => {
    setEcosystemList(e)
    const url = getEcosystemUrl(ecosystemOptions, e, ecosystemRedListCategory)
    updateFilters({ ...item, ecosystemList: e, url: url }, filterTitle)
  }

  const handleChangeRedListCategory = (e) => {
    setEcosystemRedListCategory(e)
    const url = getEcosystemUrl(ecosystemOptions, ecosystemList, e)
    updateFilters({ ...item, ecosystemRedListCategory: e, url: url }, filterTitle)
  }

  const handleChangeEcosystemQuery = (e) => {
    setEcosystemQuery(e)
  }

  return (
    <FiltersContentContainer>
      <MultiSelectionDropdown
        dataTest='Ecosystem name'
        marginTop='16px'
        label='ecosystemName'
        secondStepOptions={ecosystemOptions}
        value={ecosystemList}
        saveChanges={handleChangeEcosystemList}
        infoTooltip='ecosystemNameFilterHint'
        inputValue={ecosystemQuery}
        onInputChange={handleChangeEcosystemQuery}
        isSearchable={true}
        placeholder='selectEcosystem'
        selectAllOption={true}
      />
      <MultiSelectionDropdown
        dataTest='Ecosystem Red List Category'
        marginTop='16px'
        label='ecosystemRedListCategory'
        secondStepOptions={redListOfEcosystemCategory}
        value={ecosystemRedListCategory}
        saveChanges={handleChangeRedListCategory}
        infoTooltip='ecoRedListCategoryFilterHint'
        placeholder='selectEcosystemRedListCategory'
        selectAllOption={true}
      />
    </FiltersContentContainer>
  )
}

EcosystemFiltersContent.propTypes = {
  item: PropTypes.shape({
    ecosystemList: PropTypes.arrayOf(PropTypes.number),
    ecosystemRedListCategory: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterTitle: PropTypes.string.isRequired,
  ecosystemOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number
  })).isRequired
}

export default EcosystemFiltersContent
